import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Container, Grid, Button } from '@material-ui/core';

import Logo from '../../assets/CavaDonCarlosLogo_black.png';
import UserModel from '../../models/user-model';
import { orderConfirmationStyles } from './styles';

const OrderCreatedSuccess = () => {
    const classes = orderConfirmationStyles();
    const history = useHistory();
    
    const order = useSelector((state: any) => state.order);
    const user: UserModel = useSelector((state: any) => state.authReducer.user);

    useEffect(() => {
        if (!user.id) {
            history.push('/');
        }
    }, [user.id]);
    
    const handleClick = () => {
        history.push('/orderslist');
        localStorage.removeItem('activestep');
    }

    return (
        <Container style={{ marginBottom: '2rem' }}>
            <Grid 
                container
                direction="column"
                alignContent="center"
                alignItems="center"
            >
                <Grid item>
                    <img className={classes.image} src={Logo} alt="Cava Don Carlos Logo" />
                </Grid>
                <Grid>
                    <p className={classes.orderId}>Pedido: #{order.orderCreated.number}</p>
                </Grid>
                <Grid>
                    <CheckCircleIcon className={classes.successIcon} />
                </Grid>
                <Grid>
                    <p className={classes.paragraphContent}>Orden creada exitosamente.<br/> Pronto recibirás actualización de tu solicitud.</p>
                </Grid>
                <Grid>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={handleClick}
                    >
                        Ir a mis pedidos
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
}

export default OrderCreatedSuccess
